<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <span class="Risklabel">{{ "MInvoiceInfo" | translate }}</span>
    <div nz-row nzGutter="64">
      <div nz-col>
        <button nz-button nzType="primary" class="default-button" (click)="addRow()"><span nz-icon nzType="plus" nzTheme="outline"></span>
          {{'Add'|translate}}</button>
      </div>
      <div nz-col>
        <button nz-button nzType="primary" class="default-button"
          (click)="exportTableToExecl()"><span nz-icon nzType="download" nzTheme="outline"></span>
          {{'DownloadExcel'|translate}}</button>
      </div>
      <div nz-col>
        <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload">
          <button nz-button class="upload-button default-button">
            <span nz-icon nzType="upload" nzTheme="outline"></span>
            {{'UploadExcel'|translate}}
          </button>
        </nz-upload>
      </div>
      <div nz-col>
        <button class="default-button" nz-button (click)="WHQSubmitList()" nzType="primary" 
          [disabled]="Submitdisabled()"><span nz-icon nzType="send" nzTheme="outline"></span>
          {{'Submit'|translate}}</button>
      </div>
      <div nz-col>
        <button class="default-button" nz-button (click)="SavegetmaintainData()"
          nzType="primary"><span nz-icon nzType="save" nzTheme="outline"></span>
          {{'Save'|translate}}</button>
      </div>
      <div nz-col>
        <button nz-button nzType="primary" class="default-button" (click)="Retrun()"><span nz-icon nzType="arrow-left" nzTheme="outline"></span>
          {{'Return'|translate}}</button>
      </div>
    </div>
    <div class="表格" style="margin-top: 15px;">
      <form nz-form [formGroup]="validateForm">
        <nz-table [nzShowPagination]="false" nzSize="middle" #editRowTable nzBordered style="width: 100%;"
          [nzScroll]="{ y: '600px',x:'1000px' }">
          <thead>
            <tr>
              <th scope="col" nzWidth="150px" style="text-align: center;">{{ "PO NO." | translate}}</th>
              <th scope="col" nzWidth="150px" style="text-align: center;">{{ "InvoiceNo" | translate}}</th>
              <th scope="col" nzWidth="140px" style="text-align: center;" >{{ "InvoiceDate" | translate}}</th>
              <th scope="col" nzWidth="60px" style="text-align: center;">{{ "table.WHQCurrency" | translate}}</th>
              <th scope="col" nzWidth="100px" style="text-align: center;">{{ "InvoiceAmountBeforeTax" | translate}}</th>
              <th scope="col" nzWidth="100px" style="text-align: center;">{{ "Taxes" | translate}}</th>
              <th scope="col" nzWidth="200px" style="text-align: center;">{{ "Remark" | translate}}</th>
              <th scope="col" nzWidth="200px" style="text-align: center;">{{ "ElectronicFileInvoice" | translate}}</th>
              <th scope="col" nzWidth="180px" style="text-align: center;">{{ "OtherFiles" | translate}}</th>
              <th scope="col" nzWidth="180px" style="text-align: center;">{{ "BuyerOtherFiles" | translate}}</th>
              <th scope="col" nzWidth="50px" style="text-align: center;">{{ "act" | translate}}</th>
            </tr>
          </thead>
          <ng-container formArrayName="aliases">
            <tr [formGroupName]="i" *ngFor="let data of aliases.controls;let i=index" class="editable-row">
              <ng-container>
                <td nzHigh="100px">
                  {{data.value.Pono}}
                </td>
                <td>
                  <input type="text" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'').toUpperCase()" nz-input (mouseenter)="InvoiceNoMsgShow('InvoiceNo')" (mouseleave)="CloseInput('qqqq')"
                     formControlName="InvoiceNo" text-transform:uppercase (ngModelChange)="InvoiceNoChange(data.value)"
                    placeholder="{{'InvoiceCodeInvoiceNoRequired'|translate}}" />
                </td>
                <td>
                  <nz-date-picker formControlName="InvoiceDate" [nzFormat]="dateFormat" style="width:100%;"
                    [nzDisabledDate]="disabledDate" nzPlaceHolder="{{'selectMonth'|translate}}">
                  </nz-date-picker>
                </td>
                <td style="text-align:center;">
                  {{data.value.Currency}}
                </td>
                <td >
                  <input type="text" oninput="value=value.match(/^[0-9]+(?:\.\d{0,2})?/)" nz-input style="text-align: right; word-break:break-all;"
                    formControlName="NontaxInvoiceAmount" />
                </td>
                <td >
                  <input type="text" oninput="value=value.match(/^[0-9]+(?:\.\d{0,2})?/)" nz-input style="text-align: right; word-break:break-all;"
                     formControlName="Taxes" />
                </td>
                <td>
                  <textarea nz-input  nzAutosize formControlName="Remark"></textarea>
                </td>
                <td *ngIf="data.value.invoicefilePath!='' && data.value.invoicefilePath!=null">
                  <div >
                    <span class="linkLabel" style="text-decoration:underline;color:blue">
                      <a (click)="GetFileTokenOnClick(data)">{{data.value.invoicefileName}}</a>
                    </span>
                    <button nz-icon nzType="delete" nzTheme="outline" (click)="DeleteUploadFile(data)"></button>
                  </div>
                </td>
                <td *ngIf="data.value.invoicefilePath=='' || data.value.invoicefilePath==null ">
                  <nz-upload  [nzBeforeUpload]="beforeUploadFile">
                    <button nz-button class="upload-button default-button"  [disabled]="data.value.InvoiceNo=='' || data.value.InvoiceDate==null || data.value.NontaxInvoiceAmount==0 "
                      (click)="GetRowInfo(data.value)">
                      <em nz-icon nzType="upload"></em>{{'SelectFile'|translate}}
                    </button>
                  </nz-upload>
                </td>

                <td *ngIf="data.value.otherfilePath!='' && data.value.otherfilePath!=null">
                  <div >
                    <span class="linkLabel" style="text-decoration:underline;color:blue">
                      <a (click)="GetOtherFileTokenOnClick(data)">{{data.value.otherInvoicefileName}}</a>
                    </span>
                    <button nz-icon nzType="delete" nzTheme="outline" (click)="DeleteUploadOtherFile(data)"></button>
                  </div>
                </td>
                <td *ngIf="data.value.otherfilePath=='' || data.value.otherfilePath==null ">
                  <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUploadOtherFile">
                    <button nz-button class="upload-button default-button" 
                    (click)="GetRowInfo(data.value)" [disabled]="data.value.InvoiceNo=='' || data.value.InvoiceDate==null || data.value.NontaxInvoiceAmount==0 " >
                      <em nz-icon nzType="upload"></em>{{'SelectFile'|translate}}
                    </button>
                  </nz-upload>
                </td>


                <td *ngIf="data.value.buyerOtherFiles!='' && data.value.buyerOtherFiles!=null">
                    <div >
                      <span class="linkLabel" style="text-decoration:underline;color:blue">
                        <a (click)="GetBuyerOtherFile(data)">{{data.value.buyerOtherFilesfileName}}</a>
                      </span>
                      <button nz-icon nzType="delete" nzTheme="outline" (click)="DeleteBuyerOtherFiles(data)"></button>
                    </div>
                </td>
                
                <td *ngIf="data.value.buyerOtherFiles=='' || data.value.buyerOtherFiles==null ">
                    <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeBuyerOtherFiles">
                      <button nz-button class="upload-button default-button" 
                      (click)="GetRowInfo(data.value)" [disabled]="data.value.InvoiceNo=='' || data.value.InvoiceDate==null || data.value.NontaxInvoiceAmount==0 " >
                        <em nz-icon nzType="upload"></em>{{'SelectFile'|translate}}
                      </button>
                    </nz-upload>
                </td>
                <td style="text-align:center;">
                  <!-- <button nz-button nzType="primary" class="default-button" nzPopconfirmTitle="确定删除" (click)="deleteRow(i,data.value)"> -->
                    <span nz-icon nzType="delete" nzTheme="twotone"  (click)="deleteRow(i,data.value)" style="font-size: 20px; cursor: pointer;" nz-tooltip nzTooltipTitle="{{'Delete' | translate}}" ></span>
                    <!-- {{'Delete'|translate}}</button> -->
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </nz-table>
      </form>
    </div>
  </div>
</nz-spin>